import { Box, IconButton, styled } from "@mui/material";

export const FooterStyled = styled(({ children, ...rest }) => {
  return <Box {...rest}>{children}</Box>;
})(({ theme }) => {
  const { breakpoints, palette } = theme;
  return {
    "& .footer-promo": {
      backgroundColor: palette.background.default,
      padding: "60px 0",
      textAlign: "center",
      [breakpoints.down("md")]: {
        padding: "40px 0",
      },
      "& .footer-join": {
        "& .footer-promo-heading": {
          "& .accent": {
            color: palette.primary.main,
          },
        },
        "& .footer-promo-btn": {
          borderRadius: 14,
          color: palette.primary.main,
          borderColor: palette.primary.main,
          "&:hover": {
            backgroundColor: palette.primary.main,
            color: palette.light.main,
          },
        },
      },
    },
    "& .footer-top": {
      backgroundColor: "#111111",
      padding: "48px 0 32px",
      color: palette.light?.main || "#e6e6e6",
      [breakpoints.down("lg")]: {
        padding: "40px 0 24px",
      },
      "& .footer-col-heading": {
        fontWeight: 700,
        fontSize: "1.25rem",
        marginBottom: 20,
        color: "#ffffff",
      },
      "& .footer-desc": {
        color: "rgba(255, 255, 255, 0.75)",
        fontSize: "0.875rem",
        lineHeight: 1.6,
      },
      "& .nav-item": {
        marginBottom: 10,
        "& > .nav-link": {
          color: "rgba(255, 255, 255, 0.78)",
          textDecoration: "none",
          fontSize: "0.875rem",
          "&:hover": {
            color: palette.primary.light,
          },
        },
        "&:last-of-type": {
          marginBottom: 0,
        },
      },
      "& .contact-item": {
        display: "flex",
        alignItems: "flex-start",
        gap: 14,
        marginBottom: 20,
        "& .contact-icon": {
          flexShrink: 0,
          fontSize: 22,
          color: palette.primary.main,
          marginTop: 2,
        },
        "& .contact-text": {
          color: "rgba(255, 255, 255, 0.78)",
          fontSize: "0.875rem",
          lineHeight: 1.6,
        },
      },
      "& .contact-block": {
        marginTop: 20,
        "& .MuiTypography-root": {
          color: palette.white.main,
          fontSize: "1rem",
          fontWeight: 500,
        },
        "& .nav-link": {
          color: "rgba(255, 255, 255, 0.78)",
          textDecoration: "none",
          display: "block",
          marginBottom: 4,
          "&:hover": {
            color: palette.primary.light,
          },
        },
      },
    },
    "& .footer-bottom": {
      padding: "16px 0",
      borderTop: "1px solid rgba(255, 255, 255, 0.1)",
      backgroundColor: palette.dark?.main || "#151515",
      "& .footer-copyright": {
        color: "rgba(255, 255, 255, 0.7)",
        fontSize: "0.875rem",
      },
      "& .footer-legal-link": {
        color: "rgba(255, 255, 255, 0.7)",
        textDecoration: "none",
        fontSize: "0.875rem",
        "&:hover": {
          color: palette.primary.light,
        },
      },
    },
  };
});

export const SocialIconButton = styled(IconButton)(({ theme }) => {
  const { palette } = theme;
  return {
    transition: "all 0.3s ease",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    flexShrink: 0,
    width: 36,
    height: 36,
    "& > svg": {
      fill: palette.light?.main || "#fff",
      width: 18,
      height: 18,
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
    "&.facebook:hover": {
      backgroundColor: "#3080F8",
    },
    "&.twitter:hover": {
      backgroundColor: "#000",
    },
    "&.instagram:hover": {
      backgroundColor: "#FF2D20",
    },
    "&.youtube:hover": {
      backgroundColor: "#CD201F",
    },
  };
});
